import useSWR from "swr";
import { useCreateProductServicePublicAxiosInstance } from "../../Auth/useCreateProductServicePublicAxiosInstance.ts";
import { NormasTeachingItemType } from "../../Stripe/StripeOrderDTO.ts";

export type AllYouCanSpeakBonusDTO = {
  type: "all_you_can_speak";
  lessonsCountedPerWeek: number;
  activeFrom?: string;
  activeTo?: string;
};

export type ExtraLessonsBonusDTO = {
  type: "extra_lessons";
  extraLessons: number;
};

export type ExtraWeeksBonusDTO = {
  type: "extra_weeks";
  extraWeeks: number;
};

export type PromoBonusDTO =
  | AllYouCanSpeakBonusDTO
  | ExtraLessonsBonusDTO
  | ExtraWeeksBonusDTO;

export type PromoApplicableProductDTO = {
  itemType: NormasTeachingItemType;
  id: string;
};

export type PromoDTO = {
  _id: string;
  name: string;
  description?: string;
  bonuses: PromoBonusDTO[];
  validFrom?: string;
  validTo?: string;
  isActive: boolean;
  applicableProducts?: PromoApplicableProductDTO[];
};

export function useAllPromos() {
  const { createAxiosInstance } = useCreateProductServicePublicAxiosInstance();
  const { data, isLoading, mutate } = useSWR(`/promos`, async (url) => {
    const { data } = await createAxiosInstance().get<{ promos: PromoDTO[] }>(
      url,
    );
    return data;
  });

  return {
    promos: data?.promos ?? [],
    isLoading,
    mutate,
  };
}
